/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practicalexperiences_Level_Placeholder1Inputs */

const en_practicalexperiences_level_placeholder1 = /** @type {(inputs: Practicalexperiences_Level_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience level`)
};

const de_practicalexperiences_level_placeholder1 = /** @type {(inputs: Practicalexperiences_Level_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrungsniveau`)
};

/**
* | output |
* | --- |
* | "Experience level" |
*
* @param {Practicalexperiences_Level_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const practicalexperiences_level_placeholder1 = /** @type {((inputs?: Practicalexperiences_Level_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practicalexperiences_Level_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_practicalexperiences_level_placeholder1(inputs)
	return en_practicalexperiences_level_placeholder1(inputs)
});
export { practicalexperiences_level_placeholder1 as "practicalExperiences_level_placeholder" }